module.exports = __webpack_public_path__ + "static/img/difference.17b5fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/rorando/difference.png
// module id = EP3E
// module chunks = 0